import {
  GET_ALL_BUSINESSES_REQUEST,
  GET_ALL_BUSINESSES_SUCCESS,
  GET_ALL_BUSINESSES_FAIL,
  ADD_BUSINESS_REQUEST,
  ADD_BUSINESS_SUCCESS,
  ADD_BUSINESS_FAIL,
  GET_BUSINESS_LOG_REQUEST,
  GET_BUSINESS_LOG_SUCCESS,
  GET_BUSINESS_LOG_FAIL,
  ADD_BUSINESS_LOG_REQUEST,
  ADD_BUSINESS_LOG_SUCCESS,
  ADD_BUSINESS_LOG_FAIL,
  DELETE_BUSINESS_LOG_REQUEST,
  DELETE_BUSINESS_LOG_SUCCESS,
  DELETE_BUSINESS_LOG_FAIL
} from '../constants/BusinessConstants';

const initialState = {
  responseBody: null,
  loading: false,
  msg: null,
};

// ========== REDUCERS ==========
export const GetAllBusinesses = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_BUSINESSES_REQUEST:
      return { ...state, loading: true, msg: null };
    case GET_ALL_BUSINESSES_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };
    case GET_ALL_BUSINESSES_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };
    default:
      return state;
  }
};

export const AddBusiness = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BUSINESS_REQUEST:
      return { ...state, loading: true, msg: null };
    case ADD_BUSINESS_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };
    case ADD_BUSINESS_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };
    default:
      return state;
  }
};

export const GetBusinessInteractionLog = (state = initialState, action) => {
  switch (action.type) {
    case GET_BUSINESS_LOG_REQUEST:
      return { ...state, loading: true, msg: null };
    case GET_BUSINESS_LOG_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };
    case GET_BUSINESS_LOG_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };
    default:
      return state;
  }
};

export const AddBusinessLog = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BUSINESS_LOG_REQUEST:
      return { ...state, loading: true, msg: null };
    case ADD_BUSINESS_LOG_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };
    case ADD_BUSINESS_LOG_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };
    default:
      return state;
  }
};

export const DeleteBusinessLog = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_BUSINESS_LOG_REQUEST:
      return { ...state, loading: true, msg: null };
    case DELETE_BUSINESS_LOG_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };
    case DELETE_BUSINESS_LOG_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };
    default:
      return state;
  }
};


// Business selectors
export const selectBusinessesData = (state) => state.allbusinesses?.responseBody;
export const selectBusinessesLoading = (state) => state.allbusinesses?.loading;
export const selectBusinessesError = (state) => state.allbusinesses?.msg;

export const selectAddBusinessData = (state) => state.addbusiness?.responseBody;
export const selectAddBusinessLoading = (state) => state.addbusiness?.loading;
export const selectAddBusinessError = (state) => state.addbusiness?.msg;

export const selectBusinessLogData = (state) => state.businesslog?.responseBody;
export const selectBusinessLogLoading = (state) => state.businesslog?.loading;
export const selectBusinessLogError = (state) => state.businesslog?.msg;

export const selectAddBusinessLogData = (state) => state.addbusinesslog?.responseBody;
export const selectAddBusinessLogLoading = (state) => state.addbusinesslog?.loading;
export const selectAddBusinessLogError = (state) => state.addbusinesslog?.msg;

export const selectDeleteBusinessLogData = (state) => state.deletebusinesslog?.responseBody;
export const selectDeleteBusinessLogLoading = (state) => state.deletebusinesslog?.loading;
export const selectDeleteBusinessLogError = (state) => state.deletebusinesslog?.msg;

// License selectors
export const selectAllLicensesData = (state) => state.alllicenses?.responseBody;
export const selectAllLicensesLoading = (state) => state.alllicenses?.loading;
export const selectAllLicensesError = (state) => state.alllicenses?.msg;

// System selectors
export const selectAllSystemsData = (state) => state.system?.responseBody;

// Client selectors
export const selectAllClientsData = (state) => state.allclients?.responseBody;

// Payment selectors
export const selectPaymentByIdData = (state) => state.paymentbyid?.responseBody;
export const selectPaymentByIdLoading = (state) => state.paymentbyid?.loading;
export const selectPaymentByIdError = (state) => state.paymentbyid?.msg;

export const selectPaymentDetailsData = (state) => state.paymentdetailsbyid?.responseBody;
export const selectPaymentDetailsLoading = (state) => state.paymentdetailsbyid?.loading;
export const selectPaymentDetailsError = (state) => state.paymentdetailsbyid?.msg;

export const selectAllPaymentsData = (state) => state.allpayments?.responseBody;


export const selectAllBusinessesData = (state) => state.allbusinesses?.responseBody;
export const selectAllBusinessesLoading = (state) => state.allbusinesses?.loading;
export const selectAllBusinessesError = (state) => state.allbusinesses?.msg;